/**
 * @file
 * The input filter options used by BasstrakkMap.
 */
import * as React from 'react';

// Types
import { FilterType, NavFilterId } from '../types';

interface IProps {
  // Label for the html input.
  label: string;
  // Set checked property on radio inputs.
  isChecked: boolean;
  // Callback to handle filter click.
  handleFilterClick: (filter: FilterType) => void;
  // Filter for all, top12, and angler.
  filter: FilterType;
  // Select element that populates with options prop.
  hasOptionSelect?: boolean;
  // Option elements for angler select element.
  options?: JSX.Element[];
  // Callback to handle angler select.
  handleAnglerSelect?: (angler: string) => void;
}

class BasstrakkMapNavFilter extends React.PureComponent<IProps> {
  public static defaultProps = {
    hasOptionSelect: false,
  };

  /**
   * Lift state to BasstrakkMap when filter is clicked.
   */
  public filterClick = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { handleFilterClick, handleAnglerSelect } = this.props;

    if (handleAnglerSelect && event.target.id === NavFilterId.ANGLER_SELECT) {
      handleAnglerSelect(event.target.value);
      handleFilterClick(FilterType.ANGLER);
    } else {
      handleFilterClick(event.target.value as FilterType);
    }
  };

  public render() {
    const { filter, label, hasOptionSelect, options, isChecked } = this.props;

    return (
      <div
        className={`filter-buttons__button-wrapper filter-buttons__button-wrapper${
          hasOptionSelect ? '--angler-select' : ''
        } no-select`}
      >
        <label
          htmlFor={filter}
          className="filter-buttons__button-wrapper__filter-label"
        >
          {label}
        </label>
        {hasOptionSelect && (
          <select
            data-testid="angler-select"
            id="angler-select"
            className="angler-select"
            onChange={this.filterClick}
          >
            <option>----</option>
            {options}
          </select>
        )}
        <input
          data-testid={`radio-filter-${filter}`}
          type="radio"
          name="map-filter"
          className="filter-buttons__button-wrapper__filter-button"
          value={filter}
          id={filter}
          checked={isChecked}
          onChange={this.filterClick}
        />
      </div>
    );
  }
}

export default BasstrakkMapNavFilter;
